/* eslint-disable jsx-quotes */
import React, { Component } from 'react';
import history from '../../history';

import Loader from '../loader-component/loader';
import SelectionQuestions from '../selection-questions/selection-questions';

import './add-template-test.css';

class AddTemplateTestPresentation extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            labelTest,
            typeTest,
            maxDuration,
            minOptions,
            maxOptions,
            percentual,
            createNewTest,
            handleChangeInput,
            handleSubmit,
            formReady,
            loading,
            showQuestions,
            handleShowQuestions,
            handleHandleQuestionsAdd,
            questionsAddeds,
            checkDisableQuestionFn,
            amountQuestion,
        } = this.props;

        return (
            <section className="container-add-test">
                <h1>Adicionar teste</h1>
                <form onSubmit={handleSubmit} className="content-form">
                    <div className="line">
                        <span className="field field-label">
                            <label htmlFor="labelTest">Label</label>
                            <input
                                id="labelTest"
                                name="labelTest"
                                value={labelTest}
                                onChange={({ target }) =>
                                    handleChangeInput(target)
                                }
                                type="text"
                            />
                        </span>
                        <span className="field">
                            <label htmlFor="typeTest">Tipo de teste</label>
                            <select
                                id="typeTest"
                                name="typeTest"
                                value={typeTest}
                                onChange={({ target }) =>
                                    handleChangeInput(target)
                                }
                            >
                                <option value="">
                                    Selecione o tipo de teste
                                </option>
                                <option value="FORMACAO">Formação</option>
                                <option value="MASTER">Master</option>
                                <option value="UNIFICADO">Unificado</option>
                            </select>
                        </span>
                        <span className="field">
                            <label htmlFor="amountQuestion">
                                Quantidade de questões
                            </label>
                            <input
                                id="amountQuestion"
                                name="amountQuestion"
                                type="number"
                                value={amountQuestion}
                                onChange={({ target }) =>
                                    handleChangeInput(target)
                                }
                                min={1}
                                max={256}
                            />
                        </span>
                        <span className="field">
                            <label htmlFor="maxDuration">
                                Duração máxima em minutos
                            </label>
                            <input
                                id="maxDuration"
                                name="maxDuration"
                                type="number"
                                value={maxDuration}
                                onChange={({ target }) =>
                                    handleChangeInput(target)
                                }
                                min={5}
                                max={480}
                            />
                        </span>
                    </div>
                    <div className="line">
                        <span className="field">
                            <label htmlFor="maxOptions">
                                Quantidade máxima de opções
                            </label>
                            <input
                                id="maxOptions"
                                name="maxOptions"
                                type="number"
                                value={maxOptions}
                                onChange={({ target }) =>
                                    handleChangeInput(target)
                                }
                                min={2}
                                max={20}
                            />
                        </span>
                        <span className="field">
                            <label htmlFor="minOptions">
                                Quantidade mínima de opções
                            </label>
                            <input
                                id="minOptions"
                                name="minOptions"
                                type="number"
                                value={minOptions}
                                onChange={({ target }) =>
                                    handleChangeInput(target)
                                }
                                min={2}
                                max={maxOptions}
                            />
                        </span>
                        <span className="field">
                            <label htmlFor="percentual">
                                Porcentagem necessária para aprovação
                            </label>
                            <input
                                id="percentual"
                                type="number"
                                min={0}
                                max={100}
                                value={percentual}
                                onChange={({ target }) =>
                                    handleChangeInput(target)
                                }
                                name="percentual"
                            />
                        </span>
                    </div>
                    <button
                        onClick={() => handleShowQuestions(showQuestions)}
                        className="add-questions-button"
                        type="button"
                    >
                        {!showQuestions
                            ? 'Selecionar questões'
                            : 'Ocultar questões'}
                    </button>
                    {showQuestions && (
                        <div className="content-questions">
                            <SelectionQuestions
                                onChangeSelecteds={handleHandleQuestionsAdd}
                                questionsAlreadySelecteds={questionsAddeds}
                                checkDisableQuestionFn={checkDisableQuestionFn}
                            />
                        </div>
                    )}
                    <span className="span-question">
                        {questionsAddeds.length} novas questões adicionadas
                    </span>
                    <span className="field field-checkbox">
                        <input
                            id="createNewTest"
                            type="checkbox"
                            checked={createNewTest}
                            onChange={({ target }) =>
                                handleChangeInput({
                                    name: target.name,
                                    value: target.checked,
                                })
                            }
                            name="createNewTest"
                        />
                        <label htmlFor="createNewTest">
                            Criar novo modelo de teste?
                        </label>
                    </span>
                    <button
                        disabled={!formReady}
                        className={
                            formReady
                                ? 'save-button'
                                : 'save-button disabled-btn'
                        }
                        type="submit"
                    >
                        Salvar
                    </button>

                    <button
                        onClick={() => history.goBack()}
                        className="cancelAdd"
                        type="button"
                    >
                        Voltar
                    </button>
                </form>
                {loading > 0 && (
                    <Loader
                        show={loading > 0 ? true : false}
                        message={'Carregando, por favor aguarde...'}
                    />
                )}
            </section>
        );
    }
}

export default AddTemplateTestPresentation;



// WEBPACK FOOTER //
// ./src/components/add-template-test/add-template-test-presentation.js